<app-header></app-header>

<div class="p-4">
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Grille salariale</h2>
      <p class="text-xs text-gray-400 m-0">Définition des postes et rémunérations de base</p>
    </div>
  </div>

  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      <button (click)="add(formContent)" class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold transition-colors">+ Nouvelle grille</button>
      <button (click)="edit(formContent)" class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Modifier</button>
      <button (click)="delete()" class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">Supprimer</button>
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher..." class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-56">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2 w-8"></th>
            <th class="px-3 py-2">Poste / Échelon</th>
            <th class="px-3 py-2">Catégorie</th>
            <th class="px-3 py-2 text-end">Base</th>
            <th class="px-3 py-2 text-end">Primes</th>
            <th class="px-3 py-2 text-end">Brut</th>
            <th class="px-3 py-2 text-center">Actif</th>
          </tr>
        </thead>
        <tbody>
          @for (d of data | sampleSearch:search_text:'label' | paginate:{id:'sgPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30">
              <td class="px-3 py-2"><input type="radio" [checked]="selected_data?.id === d.id" name="sgRadio" (click)="checked(d)" class="accent-ag-red"></td>
              <td class="px-3 py-2 font-semibold text-gray-800">{{d.label}}</td>
              <td class="px-3 py-2">@if (d.category) { <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs">{{d.category}}</span> } @else { — }</td>
              <td class="px-3 py-2 text-end">{{d.base_salary | number}} F</td>
              <td class="px-3 py-2 text-end text-gray-500">{{totalAllowances(d) | number}} F</td>
              <td class="px-3 py-2 text-end font-semibold text-ag-red">{{gross(d) | number}} F</td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="d.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'">{{d.is_active ? 'Oui' : 'Non'}}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (!loading && data.length === 0) { <p class="text-center text-gray-400 py-8 text-sm">Aucune grille salariale.</p> }
    <div class="flex justify-center py-3"><pagination-controls id="sgPg" (pageChange)="getPage($event)" [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true"></pagination-controls></div>
  </div>
</div>

<ng-template #formContent let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">{{form.id ? 'Modifier' : 'Nouvelle'}} grille salariale</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <form #f="ngForm" (ngSubmit)="form.id ? update(form) : store(form)">
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Poste / Échelon *</label>
        <input name="label" [(ngModel)]="form.label" required placeholder="Ex: Enseignant échelon 1" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Catégorie</label>
        <select name="category" [(ngModel)]="form.category" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option value="">— Choisir —</option>
          @for (c of CATEGORIES; track c) { <option [value]="c">{{c}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Salaire de base (FCFA) *</label>
        <input name="base_salary" type="number" min="0" [(ngModel)]="form.base_salary" required class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Prime transport</label>
        <input name="transport_allowance" type="number" min="0" [(ngModel)]="form.transport_allowance" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Prime logement</label>
        <input name="housing_allowance" type="number" min="0" [(ngModel)]="form.housing_allowance" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Autre prime</label>
        <input name="other_allowance" type="number" min="0" [(ngModel)]="form.other_allowance" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div class="flex items-center gap-2">
        <input type="checkbox" name="is_active" [(ngModel)]="form.is_active" class="w-4 h-4 accent-ag-red">
        <label class="text-sm text-gray-600">Grille active</label>
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Description</label>
        <textarea name="description" rows="2" [(ngModel)]="form.description" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red"></textarea>
      </div>
    </div>
    <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Annuler</button>
      <button type="submit" [disabled]="f.invalid || loading" class="px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
  </form>
</ng-template>
